import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { FetchingStatus } from '@scp/ui-shared/core';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { ContentLoaderWrapper, shouldShowLoader, STANDARD_LOADER_CONFIG } from './content-loaders';
var ChartContentLoader = styled(withoutProps(ContentLoader, ['contentHeight']))(_templateObject(), function (props) {
  return props.contentHeight;
});
var barchartLoaderContent = React.createElement(React.Fragment, null, React.createElement("rect", {
  x: "0",
  y: "245",
  rx: "0",
  ry: "0",
  width: "45",
  height: "80"
}), React.createElement("rect", {
  x: "55",
  y: "180",
  rx: "0",
  ry: "0",
  width: "45",
  height: "145"
}), React.createElement("rect", {
  x: "110",
  y: "125",
  rx: "0",
  ry: "0",
  width: "45",
  height: "210"
}), React.createElement("rect", {
  x: "165",
  y: "60",
  rx: "0",
  ry: "0",
  width: "45",
  height: "275"
}), React.createElement("rect", {
  x: "220",
  y: "105",
  rx: "0",
  ry: "0",
  width: "45",
  height: "245"
}), React.createElement("rect", {
  x: "275",
  y: "180",
  rx: "0",
  ry: "0",
  width: "45",
  height: "145"
}), React.createElement("rect", {
  x: "330",
  y: "105",
  rx: "0",
  ry: "0",
  width: "45",
  height: "245"
}), React.createElement("rect", {
  x: "385",
  y: "45",
  rx: "0",
  ry: "0",
  width: "45",
  height: "285"
}), React.createElement("rect", {
  x: "440",
  y: "125",
  rx: "0",
  ry: "0",
  width: "45",
  height: "200"
}), React.createElement("rect", {
  x: "495",
  y: "160",
  rx: "0",
  ry: "0",
  width: "45",
  height: "165"
}), React.createElement("rect", {
  x: "550",
  y: "245",
  rx: "0",
  ry: "0",
  width: "45",
  height: "80"
}), React.createElement("rect", {
  x: "605",
  y: "145",
  rx: "0",
  ry: "0",
  width: "45",
  height: "180"
}));
var linechartLoaderContent = React.createElement("path", {
  d: "M 0 151 l 90 20 l 60.33 -30 h 60.666 l 59.665 -121 l 59.665 180 l 70.665 -89 l 59.665 40 h 62 l 78 -71 l 62 71 v 175 H 0 z"
});
var chartLoaderContentByType = {
  linechart: linechartLoaderContent,
  barchart: barchartLoaderContent
};
/**
 * Chart loader components
 * @example ./__docs__/ChartLoader.md
 */

export var ChartLoader = function ChartLoader(_a) {
  var _a$status = _a.status,
      status = _a$status === void 0 ? FetchingStatus.Loading : _a$status,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      height = _a.height,
      id = _a.id,
      type = _a.type,
      rest = __rest(_a, ["status", "children", "height", "id", "type"]);

  if (!shouldShowLoader(status)) return children;
  var loaderContent = chartLoaderContentByType[type];
  return React.createElement(ContentLoaderWrapper, {
    loaderWidth: 0,
    loaderHeight: height,
    as: 'div',
    fullWidth: true
  }, React.createElement(ChartContentLoader, Object.assign({}, STANDARD_LOADER_CONFIG, {
    width: 662,
    height: 326,
    contentHeight: height,
    uniquekey: id
  }, rest), loaderContent));
};